import Papa from "papaparse";

export const downloadCsv = (dataToExport, filename = "data.csv") => {
  if (!dataToExport?.length) {
    throw new Error("No data to export");
  }

  const csvData = Papa.unparse(dataToExport);
  const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.setAttribute("download", filename);
  link.click();
  URL.revokeObjectURL(url);
};

export const validateDateRange = (startDate, endDate, maxDays = 31) => {
  if (!startDate || !endDate) {
    return { valid: false, message: "Please select both start and end dates" };
  }

  if (startDate > endDate) {
    return { valid: false, message: "Start date must be before end date" };
  }

  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffInDays = (end - start) / (1000 * 60 * 60 * 24);

  if (diffInDays > maxDays) {
    return {
      valid: false,
      message: `Date range must not exceed ${maxDays} days`,
    };
  }

  return { valid: true };
};

export const getCsvFilename = (prefix) => {
  const now = new Date();
  const datePart = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  return `${prefix}_${datePart}.csv`;
};
